import { IQuotePaymentTermCodeState } from '@/store/quote-payment-term-code';
import { IQuotePaymentTermCodeGetters } from './getters.types';
import { IQuotePaymentTermCode, QuotePaymentTermCode } from '@/models';

export const getters: IQuotePaymentTermCodeGetters = {
  getQuotePaymentTermCodes(
    state: IQuotePaymentTermCodeState
  ): IQuotePaymentTermCode[] {
    return state.quotePaymentTermCodes.map(
      data => new QuotePaymentTermCode(data)
    );
  },

  getQuotePaymentTermCodeById: (state: IQuotePaymentTermCodeState) => (
    id: number
  ): IQuotePaymentTermCode | undefined => {
    const data = state.quotePaymentTermCodes.find(code => code.id === id);
    if (!data) {
      return undefined;
    }

    return new QuotePaymentTermCode(data);
  },

  getQuotePaymentTermCodeByCode: (state: IQuotePaymentTermCodeState) => (
    paymentCode: string
  ): IQuotePaymentTermCode | undefined => {
    const data = state.quotePaymentTermCodes.find(
      code => code.code === paymentCode
    );
    if (!data) {
      return undefined;
    }

    return new QuotePaymentTermCode(data);
  }
};
